import { createSelector, createFeatureSelector } from '@ngrx/store';
import { NotificationContentState } from './types';
import { DataTablePagination } from 'studio-components';
import { NotificationContentErrorTypes } from './notification-content.errors';

export const NotificationContentKey = 'notification-content';

export const getNotificationContentState =
  createFeatureSelector<NotificationContentState>(NotificationContentKey);

export const getNotificationContents = createSelector(getNotificationContentState, (state) =>
  state.ids.map((id) => state.entities[id]),
);

export const getNotificationContentById = (id: number) =>
  createSelector(getNotificationContentState, (state) => state.entities[id]);

export const getNotificationContentLoaded = createSelector(
  getNotificationContentState,
  (state) => state.loaded,
);

export const getNotificationContentError = createSelector(
  getNotificationContentState,
  (state) => state.apiError,
);

export const getNotificationContentErrorDescription = createSelector(
  getNotificationContentError,
  (error) => {
    if (!error) return null;

    switch (error.type) {
      case NotificationContentErrorTypes.NotificationContentLoadError:
        return { text: 'Cannot load notifications, try again later' };
      case NotificationContentErrorTypes.NotificationContentPublishError:
        return { text: 'Cannot publish the notification, try again later' };
      case NotificationContentErrorTypes.NotificationContentDeleteError:
        return { text: 'Cannot delete the notification, try again later' };
      case NotificationContentErrorTypes.NotificationContentPublishNotFoundError:
        return { text: 'Cannot find the notification to publish' };
      case NotificationContentErrorTypes.NotificationContentDeleteNotFoundError:
        return { text: 'Cannot find the notification to delete' };
      default:
        return { text: 'Something went wrong, try again later' };
    }
  },
);

export const getNotificationContentSort = createSelector(
  getNotificationContentState,
  (state) => state.sort,
);

export const getNotificationContentPagination = createSelector(
  getNotificationContentState,
  (state) => state.pagination,
);

export const getNotificationContentFilter = createSelector(
  getNotificationContentState,
  (state) => state.filter,
);

export const getNotificationContentQuery = createSelector(
  getNotificationContentFilter,
  getNotificationContentPagination,
  getNotificationContentSort,
  (filter, { limit, page }: DataTablePagination, sort) => ({
    limit,
    page,
    ...filter,
    ...sort,
  }),
);
